var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLogo = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 112,
  fill: "none",
  viewBox: "0 0 80 112",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3826134566__a)",
  d: "M58.012 22.653c-2.171.543-9.77 1.628-13.298 2.103-3.324 2.872-8.765 8.494-3.935 8.006 6.038-.61 15.401-2.646 19.607-4.07 2.239-.759 2.598-3.523 1.493-4.953-.972-1.258-2.597-1.403-3.867-1.086"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3826134566__b)",
  d: "M13.302 29.98c.935 4.906 8.73 4.84 12.551 4.41-1.718 2.556-5.4 9.688-6.377 17.775-1.221 10.11 5.767 20.434 18.86 19.879C49.532 71.569 59.37 61.392 64.66 54.81c5.292-6.58 1.56-11.805-.474-13.772-2.036-1.968-8.685-4.274-13.366 3.46S39.694 57.389 35.76 56.372s-1.357-8.752 0-11.873 12.008-23.542 14.518-29.105C54.01 8.27 47.2 2.022 41.457 6.03 32.05 12.6 22.3 19.05 18.73 21.364c-2.94 1.905-6.362 3.71-5.428 8.616"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3826134566__c)",
  d: "m41.67 32.664.154-.303c1.306-2.57 2.67-5.251 3.927-7.746 3.807-.523 10.284-1.468 12.26-1.962 1.27-.317 2.896-.172 3.868 1.086 1.105 1.43.746 4.194-1.493 4.952-4.004 1.357-12.683 3.267-18.717 3.973"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-3826134566__d)",
  d: "M16.3 33.45c5.55-1.2 11.25-4.65 15.049-7.744C28.75 29.85 25.9 34.35 25.9 34.35c-1.832.203-6.072.525-9.6-.9"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.043 87.132c-1.41 1.614-2.06 2.2-3.6 3.228C2.58 91.6 1.586 91.725.841 92.346c-.667.556-.718 1.57-.497 2.234.358 1.074 1.987 1.242 3.118 1.17-.97 1.703-1.616 3.937-1.877 5.585-.564 3.566 1.087 6.154 5.534 5.499 1.37-.202 3.55-1.27 4.647-2.695 1.242-1.614.745-3.033-.372-3.848-.786-.573-1.797-.192-2.564.642-.664.723-1.285 1.434-2.127 1.201-1.71-.475 1.277-6.665 1.277-6.665S11.7 95.1 13.3 94.5c1-.375 1.65-1.727 1.1-2.6-.308-.488-.933-.806-1.5-.7-1.6.3-3.266.58-3.266.58s.854-1.82 1.14-2.538c.791-1.986-1.44-3.589-2.731-2.11M19.464 95.334c-.571.389-1.354.42-1.844-.068l-.449-.443c-.594-.582-.599-1.601.09-2.067 1.38-.932 2.907-1.5 4.573-1.722 1.568-.209 3.128-.141 4.651.306.71.21 1.359.545 1.896 1.075.59.59.889 1.322.986 2.143.112.91-.075 1.792-.269 2.673-.569 2.646-1.144 5.293-1.71 7.939a1.455 1.455 0 0 1-1.413 1.165h-.18l-1.245.001a1.287 1.287 0 0 1-1.287-1.305c.003-.206.004-.402.004-.559-.022.015-.052.015-.067.03-1.202 1.097-2.635 1.687-4.21 1.985-.851.165-1.717.224-2.576.075-1.187-.209-2.173-.746-2.755-1.851-.396-.754-.463-1.561-.358-2.397.246-1.933 1.388-3.202 3.046-4.076 1.202-.634 2.657-1.124 3.986-1.385 1.456-.292 2.755-.324 4.233-.399.194-.007.262-.075.277-.268.097-1.068-.508-1.83-1.628-1.971-1.401-.173-2.652.371-3.75 1.12m4.707 3.808c-.858.07-1.504.141-2.233.254-.88.141-1.739.373-2.538.783-.463.239-.888.53-1.187.971-.75 1.12.134 2.004 1.5 1.786 1.862-.298 4.096-1.49 4.458-3.794M45.79 109.544c-.614-.732-.27-1.798.573-2.248l.78-.416c.744-.397 1.61-.143 2.24.417.565.501 1.221.85 1.997.937 1.62.179 2.934-.358 3.807-1.791.366-.59.605-1.232.799-1.911-.321.179-.62.365-.94.507-1.464.635-2.994.859-4.555.478-2.098-.508-3.39-1.889-3.979-3.934-.41-1.411-.328-2.844.008-4.255.365-1.53 1.067-2.89 2.172-4.017 1.24-1.269 2.74-2.045 4.502-2.284 1.247-.172 2.456-.045 3.606.493a5.4 5.4 0 0 1 1.754 1.306c.052.052.097.105.172.187.084-.212.167-.457.25-.71a1.85 1.85 0 0 1 1.778-1.27h1.135c.945 0 1.651.867 1.454 1.791-.117.546-.238 1.102-.325 1.48a4445 4445 0 0 1-2.247 9.742c-.336 1.456-.836 2.844-1.627 4.121-1.3 2.098-3.18 3.322-5.614 3.688-1.56.231-3.113.216-4.629-.269a6.4 6.4 0 0 1-3.11-2.042m8.008-7.245c.224-.029.456-.044.68-.089.97-.209 1.657-.821 2.157-1.643.56-.91.829-1.925.904-2.986a3.5 3.5 0 0 0-.194-1.485c-.47-1.262-1.65-1.672-2.86-1.53-.896.104-1.612.567-2.165 1.261-.948 1.195-1.306 2.576-1.142 4.069.157 1.508 1.157 2.388 2.62 2.403M72.626 90.923c1.037 0 2.329.231 3.516.88 1.702.926 2.755 2.367 3.09 4.256.523 2.934-.171 5.584-2.187 7.816-1.261 1.403-2.889 2.187-4.733 2.531-1.426.268-2.852.283-4.27-.075-1.777-.448-3.218-1.381-4.159-3.001-.597-1.03-.843-2.157-.843-3.337.007-1.836.455-3.553 1.418-5.121 1.232-2 3.039-3.18 5.316-3.68.843-.187 1.687-.262 2.852-.27m1.918 6.659c-.045-.41-.074-.829-.149-1.24-.112-.619-.336-1.186-.821-1.612-.665-.59-1.463-.702-2.307-.545-.896.172-1.56.702-2.053 1.44-1.12 1.695-1.434 3.562-1.105 5.54.097.612.35 1.18.821 1.598.806.709 1.747.754 2.71.418.874-.306 1.463-.971 1.911-1.755.687-1.187.948-2.478.993-3.844M30.222 106.325a1.245 1.245 0 0 1-1.213-1.512c.9-4.104 1.8-8.333 2.697-12.424a1.736 1.736 0 0 1 1.696-1.364h1.155c.822 0 1.406.66 1.29 1.475-.029.2-.049.395-.049.573.09-.068.142-.105.187-.142 1.276-1.075 2.732-1.755 4.397-1.956 1-.12 1.986-.067 2.941.284 1.217.448 1.926 1.336 2.195 2.59.232 1.082.135 2.157-.09 3.218-.516 2.453-1.185 5.845-1.657 7.931a1.666 1.666 0 0 1-1.64 1.288h-1.892a1.237 1.237 0 0 1-1.208-1.507l.05-.23c.53-2.371 1.063-4.737 1.585-7.11.119-.544.171-1.104.022-1.664-.172-.642-.627-1.03-1.292-1.083-1.463-.126-2.583.47-3.389 1.673-.538.806-.806 1.717-1 2.65q-.622 2.926-1.251 5.858l-.022.099a1.73 1.73 0 0 1-1.694 1.356z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3826134566__a",
  x1: 62.422,
  x2: 38.812,
  y1: 23.942,
  y2: 29.777,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD00CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD00CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3826134566__b",
  x1: 25.614,
  x2: 60.431,
  y1: 12.117,
  y2: 66.389,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.066,
  stopColor: "#FF0451"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.207,
  stopColor: "#FF006A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.378,
  stopColor: "#FC1FA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.544,
  stopColor: "#FE00CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.816,
  stopColor: "#B30CE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8204FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3826134566__c",
  x1: 18.7,
  x2: 51.251,
  y1: 28.5,
  y2: 40.74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.065,
  stopColor: "#92077F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "#8D067D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.678,
  stopColor: "#8D008C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#8E067E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-3826134566__d",
  x1: 18.7,
  x2: 51.251,
  y1: 28.5,
  y2: 40.74,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.065,
  stopColor: "#92077F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "#8D067D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.678,
  stopColor: "#8D008C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#8E067E",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };